export default "__VITE_ASSET__BytNkNVD__"